import { render, staticRenderFns } from "./TargetCircles.vue?vue&type=template&id=75ac25ec&scoped=true&"
import script from "./TargetCircles.vue?vue&type=script&lang=js&"
export * from "./TargetCircles.vue?vue&type=script&lang=js&"
import style0 from "./TargetCircles.vue?vue&type=style&index=0&id=75ac25ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ac25ec",
  null
  
)

export default component.exports